import { ToolBase, ToolDescription } from "../../../agents/base";
import { createTelemetry, resolveSessionId, unwrapRequest, } from "../readHelpers";
import { FormulaTraceParamsSchema, } from "./formulaTrace.schema";
const SYSTEM_PROMPT_DESCRIPTION = `### formulaTrace
Trace formula references (precedents/dependents metadata).`;
export function createFormulaTraceTool(runner, fallbackSessionId) {
    return new FormulaTraceTool(runner, fallbackSessionId).toRuntimeToolDefinition();
}
export class FormulaTraceTool extends ToolBase {
    constructor(runner, fallbackSessionId) {
        super();
        this.runner = runner;
        this.fallbackSessionId = fallbackSessionId;
        this.name = "formulaTrace";
        this.description = new ToolDescription("formulaTrace", "Trace formula references (precedents/dependents metadata).", FormulaTraceParamsSchema);
        this.paramsSchema = FormulaTraceParamsSchema;
        this.systemPromptDescription = SYSTEM_PROMPT_DESCRIPTION;
    }
    setSessionId(sessionId) {
        this.fallbackSessionId = sessionId;
    }
    async execute(args) {
        const startedAt = Date.now();
        const sessionId = resolveSessionId(args, this.fallbackSessionId);
        const request = unwrapRequest(args);
        const formulaTrace = request.formulaTrace || [];
        const result = await this.runner.read({ formulaTrace }, { sessionId });
        const payload = (result.data || {});
        const formulaTraceResult = payload.formulaTrace || [];
        return {
            ...result,
            data: { formulaTrace: formulaTraceResult },
            results: { formulaTrace: formulaTraceResult },
            telemetry: result.telemetry || createTelemetry(formulaTrace.length, startedAt),
        };
    }
}
